export default __webpack_public_path__ + "static/media/Share.50dc3b94.svg";